// ═══════════════════════════════════════════════════════════════════════════════
// Future due-date banner copy (employer short / helper with reminder)
// ═══════════════════════════════════════════════════════════════════════════════

import { USER_ROLE, type UserRole } from '@fdh/shared';
import { diffCalendarDaysYmd } from './taskEarlySubmit';

type TranslateFn = (key: string, params?: Record<string, string | number>) => string;

export const getFutureDueRelativeDays = (todayYmd: string, dueDateYmd: string): number | null => {
  if (dueDateYmd <= todayYmd) {
    return null;
  }
  const days = diffCalendarDaysYmd(todayYmd, dueDateYmd);
  if (days < 1) {
    return null;
  }
  return days;
};

export const getFutureDueBannerMessage = (
  role: UserRole | undefined,
  todayYmd: string,
  dueDateYmd: string,
  t: TranslateFn,
): string | null => {
  const days = getFutureDueRelativeDays(todayYmd, dueDateYmd);
  if (days === null) {
    return null;
  }
  const isEmployer = role === USER_ROLE.EMPLOYER;
  if (days === 1) {
    return isEmployer
      ? t('task.review.futureDueEmployerTomorrow')
      : t('task.review.futureDueHelperTomorrow');
  }
  return isEmployer
    ? t('task.review.futureDueEmployerDays', { days })
    : t('task.review.futureDueHelperDays', { days });
};

/** Helper submit confirm modal — e.g. 2026-05-22 (明天) / 2026-05-23 (2天後) */
export const formatSubmitConfirmDueDateLine = (
  todayYmd: string,
  dueDateYmd: string,
  t: TranslateFn,
): string => {
  const days = getFutureDueRelativeDays(todayYmd, dueDateYmd);
  if (days === null) {
    return dueDateYmd;
  }
  if (days === 1) {
    return t('task.submitConfirm.dueDateTomorrow', { date: dueDateYmd });
  }
  return t('task.submitConfirm.dueDateDaysLater', { date: dueDateYmd, days });
};
